import { __assign } from "tslib";
import React from 'react';
import { default as ConfirmationModal, } from '../../Popup/ConfirmationModal';
import { useTranslation } from 'react-i18next';
import { PremiumTrash, Lock, Unlock } from '@wix/da-ds/pkg/Icons/Confirmations';
export var CommissionConfirmation = function (_a) {
    var _b = _a.isOpen, isOpen = _b === void 0 ? false : _b, confirmationType = _a.confirmationType, onConfirm = _a.onConfirm, onCancel = _a.onCancel;
    var t = useTranslation().t;
    var content = {
        remove: {
            title: t('commission.delete.confirmHeader'),
            text: t('commission.delete.confirmText'),
            confirmBtnLabel: t('commission.delete.confirmButton'),
            confirmBtnType: 'danger',
            icon: React.createElement(PremiumTrash, null),
        },
        enable: {
            title: t('commission.enable.confirmHeader'),
            text: t('commission.enable.confirmText'),
            confirmBtnLabel: t('commission.enable.confirmButton'),
            icon: React.createElement(Unlock, null),
        },
        enableAll: {
            title: t('commission.enableAll.confirmHeader'),
            text: t('commission.enableAll.confirmText'),
            confirmBtnLabel: t('commission.enableAll.confirmButton'),
            icon: React.createElement(Unlock, null),
        },
        disable: {
            title: t('commission.disable.confirmHeader'),
            text: t('commission.disable.confirmText'),
            confirmBtnLabel: t('commission.disable.confirmButton'),
            confirmBtnType: 'danger',
            icon: React.createElement(Lock, null),
        },
        disableAll: {
            title: t('commission.disableAll.confirmHeader'),
            text: t('commission.disableAll.confirmText'),
            confirmBtnLabel: t('commission.disableAll.confirmButton'),
            confirmBtnType: 'danger',
            icon: React.createElement(Lock, null),
        },
        disableLast: {
            title: t('commission.disableLast.confirmHeader'),
            text: t('commission.disableLast.confirmText'),
            confirmBtnLabel: t('commission.disableLast.confirmButton'),
            confirmBtnType: 'danger',
            icon: React.createElement(Lock, null),
        },
        discardChanges: {
            title: t('commission.confirm.discardChanges.header'),
            text: t('commission.confirm.discardChanges.text'),
            confirmBtnLabel: t('popup.discardChanges'),
            confirmBtnType: 'danger',
            icon: React.createElement(PremiumTrash, null),
        },
        leaveCreating: {
            title: t('commission.confirm.discard.header'),
            text: t('commission.confirm.discard.text'),
            confirmBtnLabel: t('popup.discard'),
            confirmBtnType: 'danger',
            icon: React.createElement(PremiumTrash, null),
        },
    };
    return (React.createElement(ConfirmationModal, __assign({}, content[confirmationType], { onCancel: onCancel, onConfirm: onConfirm, isOpen: isOpen })));
};
CommissionConfirmation.displayName = 'CommissionConfirmation';
export default CommissionConfirmation;
//# sourceMappingURL=CommissionConfirmation.js.map